<div class="relative lg:flex">
    <header class="text-gray-100 bg-gray-800 md:hidden">
        <div (focus)="true" class="container flex items-center justify-between p-4 mx-auto">
            <a href="#" class="text-white">
                <div class="w-10">
                    <app-logo />
                </div>
            </a>
            <button (click)="isOpen=!isOpen"
                class="burgerMenu p-1 text-white rounded-lg focus:outline-none hover:bg-gray-700">
                @if (!isOpen) {
                <svg xmlns="http://www.w3.org/2000/svg" class="burgerMenu size-7" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
                </svg>
                }
            </button>
        </div>
    </header>

    <div ng-cloak [ngClass]="isOpen ? 'block' : 'hidden'"
        class="fixed inset-0 z-20 transition-opacity bg-black opacity-30 md:hidden"></div>

    <aside #sidebar id="sidebar" [ngClass]="isOpen ? 'translate-x-0 ease-in' : '-translate-x-full ease-out'"
        class="fixed inset-y-0 z-30 flex flex-col w-16 min-h-screen space-y-4 overflow-y-auto text-gray-100 transition duration-200 transform bg-linear-to-b from-blue-600 to-gray-950 md:translate-x-0 md:inset-0">
        <div class="flex flex-col items-center flex-1 space-y-4">
            @if (isOpen) {
            <button (click)="isOpen = !isOpen" class="p-2 text-white rounded-lg focus:outline-none hover:bg-gray-700">
                <svg class="size-6 transition duration-200 ease-in-out" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
            }
            <a routerLink="/dashboard"
                class="flex items-center justify-center w-full px-3 py-4 lg:p-0 lg:h-16 font-bold text-white truncate bg-transparent whitespace-nowrap">
                <div class="w-10">
                    <app-logo />
                </div>
            </a>
            <nav class="flex flex-col items-center space-y-1 md:space-y-2">
                <!-- Dashboard -->
                <a routerLink="/dashboard"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" pTooltip="Dashboard" tooltipPosition="right">
                    <i class="pi pi-home text-white text-xl"></i>
                </a>

                <!-- Fleet Management -->
                <a routerLink="/fleet"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" [routerLinkActiveOptions]="{ exact: true }" pTooltip="Fleet Management" tooltipPosition="right">
                    <i class="pi pi-truck text-white text-xl"></i>
                </a>

                <!-- Data Configuration -->
                <a routerLink="/data-config"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" pTooltip="Data Configuration" tooltipPosition="right">
                    <i class="pi pi-sitemap text-white text-xl"></i>
                </a>

                <!-- Process Updates (Prozessabbild) -->
                <a routerLink="/process-updates"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" pTooltip="Process Updates" tooltipPosition="right">
                    <i class="pi pi-chart-line text-white text-xl"></i>
                </a>

                <!-- AI Insights -->
                <a routerLink="/ai-insights"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" pTooltip="AI Insights" tooltipPosition="right">
                    <i class="pi pi-sparkles text-white text-xl"></i>
                </a>

                <!-- Audit Logs -->
                <a routerLink="/audit-logs"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" pTooltip="Audit Logs" tooltipPosition="right">
                    <i class="pi pi-file-edit text-white text-xl"></i>
                </a>

                <!-- Certificate Management -->
                <a routerLink="/certificate-management"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" pTooltip="Certificate Management" tooltipPosition="right">
                    <i class="pi pi-shield text-white text-xl"></i>
                </a>

                <!-- Licensing -->
                <a routerLink="/licensing"
                    class="flex items-center justify-center w-11 h-11 transition-colors duration-300 rounded-xl group hover:bg-white/20"
                    routerLinkActive="active bg-primary" pTooltip="Licensing" tooltipPosition="right">
                    <i class="pi pi-key text-white text-xl"></i>
                </a>
            </nav>
        </div>
    </aside>
</div>